import { render } from "./create_new_bill.vue?vue&type=template&id=bb343694&scoped=true"
import script from "./create_new_bill.vue?vue&type=script&lang=js"
export * from "./create_new_bill.vue?vue&type=script&lang=js"

import "./create_new_bill.vue?vue&type=style&index=0&id=bb343694&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb343694"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn,QCardActions});qInstall(script, 'directives', {ClosePopup});
